import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { NutritionIcon } from 'components/Icons';

const propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  theme: PropTypes.object,
};

const NutritionThemedIcon = ({ className, width, height, theme }) => (
  <NutritionIcon className={className} width={width} height={height} fill={theme.color.nutrition} />
);

NutritionThemedIcon.propTypes = propTypes;

export default withTheme(NutritionThemedIcon);
